import {buildErrorPayload, errorToPlainObject} from './errorPayload';
import {createErrorTransport} from './errorTransport';
import {
  getFrontendLoggingEndpointConfigs,
  isLocalDevelopment,
} from './errorReportingEndpoints';
import {
  instrumentBrowserRuntime,
  isBotUserAgent,
  isCanceledError,
  isNetworkConnectivityError,
} from './browserInstrumentation';

const recoveryPopupIgnoredTypes = ['resource-error', 'request-access-error', 'http-request-error'];
let initialized = false;
let transports = null;

function isErrorReportingEnabled() {
  if (!document.kvConfig) {
    return false;
  }

  return document.kvConfig.frontendErrorReportingEnabled !== false
    && document.kvConfig.frontendErrorReportingEnabled !== 'false';
}

function shouldCaptureResourceErrors() {
  return !!(document.kvConfig && document.kvConfig.frontendLoggingResourceErrors === true);
}

function shouldLogErrorsToConsole() {
  if (document.kvConfig && document.kvConfig.frontendErrorConsoleLoggingEnabled !== undefined) {
    return document.kvConfig.frontendErrorConsoleLoggingEnabled !== false
      && document.kvConfig.frontendErrorConsoleLoggingEnabled !== 'false';
  }

  return isLocalDevelopment();
}

function logFatalErrorToConsole(type, error, payload) {
  if (!shouldLogErrorsToConsole() || typeof console === 'undefined' || !console.error) {
    return;
  }

  console.error('[visualizer fatal error]', type, error, payload);
}

function showRecoveryPopup() {
  try {
    const {showFatalErrorRecoveryPopup} = require('./errorRecoveryPopup');

    showFatalErrorRecoveryPopup();
  } catch (error) {
    // Early bootstrap failures can happen before the React/Redux recovery UI is ready.
  }
}

function handleNetworkConnectivityError() {
  try {
    const {handleNetworkConnectionError} = require('./errorRecoveryPopup');

    handleNetworkConnectionError();
  } catch (error) {
    // Early bootstrap failures can happen before the React/Redux recovery UI is ready.
  }
}

export function initializeErrorReporting() {
  if (initialized || !isErrorReportingEnabled()) {
    return;
  }

  initialized = true;
  const endpointConfigs = getFrontendLoggingEndpointConfigs();
  transports = endpointConfigs.map((config) => createErrorTransport(config.url, {
    formatPayload: config.formatPayload,
    ...config.transportOptions,
  }));
  window.__visualizerErrorReporter = {
    reportFatalError,
    reportNonFatalError,
  };

  instrumentBrowserRuntime({
    reportFatalError,
    captureResourceErrors: shouldCaptureResourceErrors(),
  });
}

export function instrumentReduxStore() {
  initializeErrorReporting();
}

export function reportFatalError(type, error, extra) {
  reportError(type, error, extra, true);
}

export function reportNonFatalError(type, error, extra) {
  initializeErrorReporting();
  reportError(type, error, extra, false);
}

function reportError(type, error, extra, shouldShowRecoveryPopup) {
  if (isBotUserAgent()) {
    return;
  }

  if (isCanceledError(error)) {
    return;
  }

  if (isNetworkConnectivityError(error)) {
    if (shouldShowRecoveryPopup) {
      handleNetworkConnectivityError();
    }
    return;
  }

  const errorData = errorToPlainObject(error);
  const payload = buildErrorPayload({
    type,
    errorData,
    extra: extra || {},
  });

  logFatalErrorToConsole(type, error, payload);

  if (transports) {
    transports.forEach((transport) => transport.send(payload));
  }

  if (shouldShowRecoveryPopup && recoveryPopupIgnoredTypes.indexOf(type) === -1) {
    showRecoveryPopup();
  }
}
